<template>
    <div style="direction: rtl;">
        <label for="expirationDate" style="display: block;margin-bottom: 0.1em;font-weight: bold;">
            {{ $t('OPERATION_EXPIRATION_DATE') }}
            <font-awesome-icon :icon="['fa', 'calendar-days']" />
        </label>
        <div id="expirationDate" :class="operation.expiringSoon === true ? 'expiring' : ''">
            {{ getExpiration() }}
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, inject } from 'vue'
import { operationTypeEnum } from '@/helpers/Constants'
import { useI18n } from 'vue-i18n'

const dialogRef = inject("dialogRef")
const i18n = useI18n()
const operation = ref()

onBeforeMount(() => {
    operation.value = dialogRef.value.data.operation
})

const isTimeLimitedOperation = () => {
    return operation.value.typeId === operationTypeEnum.BORROWING ||
        (operation.value.typeId === operationTypeEnum.EXCHANGE && operation.value.expiration !== undefined && operation.value.expiration !== null)
}

const getExpiration = () => {
    if (isTimeLimitedOperation()) {
        return operation.value.expiration.toLocaleString()
    }
    return i18n.t('NON_EXPIRING_OPERATION')
}
</script>

<style scoped>
.expiring {
    color: red;
    font-weight: bold;
}
</style>